import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { MenuItem } from "primeng/api";
import { ContextMenu } from "primeng/contextmenu";
import { FileUtility } from "../../../shared/utility/file.utility";
import { ActiontrackerService } from "../../../actiontracker/services/actiontracker.service";
import { MasterscreenService } from "../../../masterscreen/services/masterscreen.service";
import { ObservationService } from "../../../observation/services/observation.service";
import { DashboardFilter } from "../../../shared/models/dashboardFilter.model";
import { IndependentPermissions } from "../../../shared/models/IndependentPermissions.model";
import { BaseService } from "../../../shared/services/base.service";
import { NotificationsService } from "../../../shared/services/notification.service";
import { InspectionConstantsService } from "../../Services/inspection-constants.service";
import { InspectionService } from "../../Services/inspection.service";
import { coerceNumberProperty } from "@angular/cdk/coercion";

@Component({
  selector: "ara-inspections-overview",
  templateUrl: "./inspections-overview.component.html",
  styleUrls: ["./inspections-overview.component.css"],
})
export class InspectionsOverviewComponent implements OnInit {
  @ViewChild("cm") contextMenu: ContextMenu;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  checkListDetails: any;
  loggedInUserJSON: any;
  inspectionData: any = [];
  inspectionCheckLists: any;
  inspectionFilter: DashboardFilter;
  pageSize: number = 1;
  itemsPerPage: number = 50;
  showPagination: boolean = true;
  rowCount: number;
  searchModified: boolean;
  hideFilter: boolean;
  hideSort: boolean;
  searchText: string = "";
  dataLoaded: boolean;
  selectedInspection: any;
  contextItems: MenuItem[] = [];
  columnList: { key: string; value: string }[];
  jsonString: string;
  selectedCheckLists: number[] = [];
  inspectionFromDate: Date = null;
  inspectionToDate: Date = null;
  itemPerPage: number = 50;
  alertType: string;
  successDetails: string;
  errorDetails: string;
  confirmMessage: string;
  row: HTMLElement;
  isInspectionsChecked: boolean = true;
  checked: any;
  zip: any;
  inspectionSourceIdsDetails: any = [];
  currentSourceRowCount: number;
  itemsToProcess: any;
  itemsProcessed: number;
  window = window;
  permissions: IndependentPermissions;
  unitList: any;
  selectedUnit: number[];
  inspectionStatus: any[];
  selectedStatusId: any[];
  currentId: number;
  disableExport: boolean = false;
  RedirectFromDashboard : number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private inspectionService: InspectionService,
    private baseService: BaseService,
    private masterscreenService: MasterscreenService,
    private notificationsService: NotificationsService,
    private observationService: ObservationService,
    private actionTrackerService: ActiontrackerService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.baseService.showRootLoader = true;
    this.contextItems = [
      {
        label: "Open In New Tab",
        icon: "fa-external-link-square",
        command: (e) => this.openInspection(),
      },
    ];
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    let routes = JSON.stringify(
      InspectionConstantsService.InspectionNavigation.Routes
    );
    this.routesFlag = JSON.parse(routes);
    this.reportRoutes = InspectionConstantsService.InspectionNavigation.ReportRoutes;
    this.route.params.subscribe(params => {
      this.RedirectFromDashboard = isNaN(params["D"])? 0 :coerceNumberProperty(params["D"]);
    });
    this.masterscreenService.getCheckListNames(
      null,
      this.callbackMethodForGetCheckLists.bind(this)
    );
    this.permissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    if (
      !this.permissions.INSP_Add &&
      !this.permissions.INSP_Add_Unit &&
      !this.permissions.INSP_Admin &&
      !this.permissions.INSP_Admin_Unit
    ) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === "Add Inspection") {
          this.routesFlag.splice(index, 1);
        }
      }
    }
    this.inspectionFilter = new DashboardFilter();
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }
  callbackMethodForGetCheckLists(response) {
    this.inspectionCheckLists = [];
    this.checkListDetails = response.Result;
    this.checkListDetails.forEach((check) => {
      this.inspectionCheckLists.push({
        label: check.CheckListName,
        value: check.CheckListId,
      });
      this.selectedCheckLists.push(check.CheckListId);
    });
    this.dataLoaded = true;
    this.getProcess();
  }
  getProcess() {
    this.actionTrackerService.getProcess(
      this.callbackMethodForgetProcess.bind(this)
    );
  }
  callbackMethodForgetProcess(response) {
    if (response.Success) {
      response.Result.forEach((process) => {
        if (process.ProcessName === "Inspection") {
          this.getStatusByProcessId(process.ProcessId);
        }
      });
    }
  }
  getStatusByProcessId(processId) {
    const apiRequest = {
      Model: {
        ProcessId: processId,
      },
    };
    this.actionTrackerService.getStatusByProcessId(
      apiRequest,
      this.callbackMethodForgetStatus.bind(this)
    );
  }
  callbackMethodForgetStatus(response) {
    this.inspectionStatus = [];
    this.selectedStatusId = [];
    if (response.Success) {
      response.Result.forEach((element) => {
        if (element.StatusName === InspectionConstantsService.Status.Done) {
          this.inspectionStatus.push({
            label: element.StatusName,
            value: element.StatusId,
            checked: true,
          });
        }
        this.selectedStatusId.push(element.StatusId);
      });
      if (this.permissions.SUPER_Admin) {
        response.Result.forEach((element) => {
          if (
            element.StatusName ===
            InspectionConstantsService.Status.Cancelled ||
            element.StatusName === InspectionConstantsService.Status.Deleted
          ) {
            this.inspectionStatus.push({
              label: element.StatusName,
              value: element.StatusId,
              checked: true,
            });
          }
          this.selectedStatusId.push(element.StatusId);
        });
      }
    }
    this.getUnits();
  }
  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      const unitDetails = response.Result;
      this.unitList = [];
      this.selectedUnit = [];
      unitDetails.forEach((unit) => {
        this.unitList.push({
          label: unit.UnitName,
          value: unit.UnitId,
          checked: true,
        });
        this.selectedUnit.push(unit.UnitId);
      });
    }
    this.baseService.showRootLoader = false;
    this.getInspectionData();
  }
  getInspectionData() {
    if(this.RedirectFromDashboard == 1)
    {
      this.reset();
      const filter = JSON.parse(this.baseService.getFilterData('dashboardFilter'));
      if(filter)
      {
        this.inspectionFromDate = new Date(filter.Model.FromDateForOverview);
        this.inspectionToDate = new Date(filter.Model.ToDateForOverview);
      }
    }
    this.baseService.showRootLoader = true;
    if (!this.rowCount) {
      this.rowCount = this.itemPerPage * 2;
    }
    if (!this.selectedUnit.length) {
      this.unitList.forEach((element) => {
        element.checked = true;
        this.selectedUnit.push(element.value);
      });
    }
    this.inspectionFilter.UserId = this.loggedInUserJSON.UserId;
    this.inspectionFilter.CurrentPage = this.pageSize;
    this.inspectionFilter.PageSize = this.itemsPerPage;
    this.inspectionFilter.SearchText = this.searchText;
    this.inspectionFilter.CheckLists = this.selectedCheckLists;
    this.inspectionFilter.FromDate =
      this.inspectionFromDate !== null
        ? new Date(this.inspectionFromDate.setHours(0, 0, 0, 0))
        : this.inspectionFromDate;
    this.inspectionFilter.ToDate =
      this.inspectionToDate !== null
        ? new Date(this.inspectionToDate.setHours(23, 59, 59, 0))
        : this.inspectionToDate;
    this.inspectionFilter.SelectAll = this.isInspectionsChecked;
    this.inspectionFilter.UnitId = 0;
    this.inspectionFilter.Units = this.selectedUnit;
    this.inspectionFilter.StatusId = this.selectedStatusId;
    if (!this.inspectionFilter.OrderdByColoumName) {
      this.inspectionFilter.OrderdByColoumName =
        InspectionConstantsService.ColumnConstants.InspectionDate;
    }
    if (!this.inspectionFilter.OrderdBy) {
      this.inspectionFilter.OrderdBy =
        InspectionConstantsService.ColumnConstants.DESC;
    }
    const filter = JSON.parse(
      this.baseService.getItemFromSession("inspectionFilter")
    );
    if (!this.searchModified && filter) {
      this.inspectionFilter = filter;
      this.pageSize = parseInt(filter.CurrentPage);
      if (this.pageSize === 1) {
        this.inspectionFilter.PageIndex = 0;
      } else {
        this.inspectionFilter.PageIndex = ((this.pageSize * this.itemPerPage) - this.itemPerPage);
        this.rowCount = ((this.pageSize + 1) * this.itemPerPage);
      }
      this.selectedCheckLists = filter.CheckLists;
      this.inspectionFromDate =
        filter.FromDate === null ? filter.FromDate : new Date(filter.FromDate);
      this.inspectionToDate =
        filter.ToDate === null ? filter.ToDate : new Date(filter.ToDate);
      this.selectedUnit = filter.Units;
      this.isInspectionsChecked = filter.SelectAll;
      this.selectedStatusId = filter.StatusId;
      if (!this.inspectionService.getAllInspectionIds()) {
        this.isInspectionsChecked = true;
        this.inspectionFilter.SelectAll = true;
      }
    } else {
      this.baseService.setFilterData(
        "inspectionFilter",
        JSON.stringify(this.inspectionFilter)
      );
    }
    const apiRequest = {
      Model: this.inspectionFilter,
    };
    this.inspectionService.getInspectionData(
      apiRequest,
      this.callbackMethodForGetInspectionData.bind(this)
    );
  }
  callbackMethodForGetInspectionData(response) {

    if (response && response.Success) {
      //BOC Pritesh
      if(response.Result.length > 0)
      {
      response.Result.forEach((element,index) => {
        if(element.Status ==='Draft' && element.CreatedBy !== this.loggedInUserJSON.UserId)  
        {
          response.Result.splice(index,1);
        }
      });
      }
       //EOC Pritesh
      this.inspectionData = response.Result;
      if (response.Result.length < this.itemPerPage) {
        this.rowCount = this.rowCount - this.itemPerPage;
      }
      if (this.inspectionFilter.SelectAll && !this.searchModified) {
        this.selectAllInspections(this.inspectionFilter.SelectAll);
      } else if (this.searchModified) {
        this.inspectionFilter.SelectAll = true;
        this.inspectionService.setAllInspectionIds([]);
        this.selectAllInspections(this.inspectionFilter.SelectAll);
      } else {
        if (this.inspectionService.getAllInspectionIds()) {
          this.inspectionData.forEach((element) => {
            this.inspectionService.getAllInspectionIds().forEach((stored) => {
              if (element.InspectionRequestId === stored.InspectionId) {
                element.Checked = true;
              }
            });
          });
        }
      }
      this.inspectionData.forEach((element) => {
        element.InspectionDate = new Date(
          moment(moment.utc(element.InspectionDate).local()).format(
            "MMM D, YYYY LT"
          )
        );
        element.CreatedDate = new Date(
          moment(moment.utc(element.CreatedDate).local()).format(
            "MMM D, YYYY LT"
          )
        );
      });
    }
    this.baseService.showRootLoader = false;
  }
  ascInspectionId() {
    this.inspectionFilter.OrderdByColoumName =
      InspectionConstantsService.ColumnConstants.InspectionId;
    this.inspectionFilter.OrderdBy =
      InspectionConstantsService.ColumnConstants.ASC;
    this.searchModified = true;
    this.getInspectionData();
  }
  descInspectionId() {
    this.inspectionFilter.OrderdByColoumName =
      InspectionConstantsService.ColumnConstants.InspectionId;
    this.inspectionFilter.OrderdBy =
      InspectionConstantsService.ColumnConstants.DESC;
    this.searchModified = true;
    this.getInspectionData();
  }
  ascInspectionDate() {
    this.inspectionFilter.OrderdByColoumName =
      InspectionConstantsService.ColumnConstants.InspectionDate;
    this.inspectionFilter.OrderdBy =
      InspectionConstantsService.ColumnConstants.ASC;
    this.searchModified = true;
    this.getInspectionData();
  }
  descInspectionDate() {
    this.inspectionFilter.OrderdByColoumName =
      InspectionConstantsService.ColumnConstants.InspectionDate;
    this.inspectionFilter.OrderdBy =
      InspectionConstantsService.ColumnConstants.DESC;
    this.searchModified = true;
    this.getInspectionData();
  }
  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      this.searchModified = false;
    }
    this.hideSort = false;
  }
  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }
  clearSearch() {
    this.searchText = "";
    this.searchModified = true;
    this.getInspectionData();
    this.inspectionService.setAllInspectionIds([]);
  }
  searchData() {
    this.inspectionFilter.SearchText = this.searchText;
    this.searchModified = true;
    this.getInspectionData();
    this.inspectionService.setAllInspectionIds([]);
  }
  getServerData(event) {
    if (event === 1) {
      this.inspectionFilter.PageIndex = 0;
    } else {
      this.inspectionFilter.PageIndex = ((event * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((event + 1) * this.itemPerPage);
    }
    this.pageSize = event;
    this.searchModified = true;
    this.getInspectionData();
  }
  showContextMenu(inspection) {
    this.selectedInspection = inspection.InspectionRequestId;
  }
  openInspection() {
    window.open(
      "/inspection/add-inspection/" + this.selectedInspection,
      "_blank"
    );
    this.contextMenu.hide();
  }
  exportToExcel() {
    this.disableExport = true;
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const filter = JSON.parse(
      this.baseService.getFilterData("inspectionFilter")
    );
    filter.SourceIds = [];
    this.inspectionService.getAllInspectionIds().forEach((element) => {
      filter.SourceIds.push(element.InspectionId);
    });
    const apiRequest = {
      Model: filter,
    };
    this.inspectionService.exportToExcelInspectionData(
      apiRequest,
      this.callbackMethodForExportToExcel.bind(this)
    );
  }
  callbackMethodForExportToExcel(response) {

    if (response.Success) {
      response.Result.forEach((element) => {
        element.InspectionDate = new Date(
          moment(moment.utc(element.InspectionDate).local()).format(
            "MMM D, YYYY LT"
          )
        );
        element.CreatedDate = new Date(
          moment(moment.utc(element.CreatedDate).local()).format(
            "MMM D, YYYY LT"
          )
        );
        element.InspectionRequestId = "INS".concat(element.InspectionRequestId);
        element.IsJobStopped = element.IsJobStopped == "true" ? "Yes" : "No";
      });
      this.columnList = [
        { key: "InspectionRequestId", value: "ID" },
        { key: "ContractorName", value: "Contractor Name" },
        { key: "InspectionName", value: "Inspection Name" },
        { key: "IsJobStopped", value: "Did Job Stopped" },
        { key: "InspectionDescription", value: "Inspection Description" },
        { key: "InspectionDate", value: "Inspection Date" },
        { key: "UnitName", value: "Unit" },
        { key: "ContractNumber", value: "Contract Number" },
        { key: "ContractHolderName", value: "Contract Holder Name" },
        { key: "CreatedDate", value: "Submission Date" },
        { key: "Status", value: "Status" },
        { key: "InspectorFullName", value: "InspectorFullName" }

 
      ];
      const parsedResponse: any = FileUtility.convertToCSV(response.Result, this.columnList);
      FileUtility.downloadCSV(parsedResponse, "InspectionReport.csv");
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  doneFilter() {
    if (this.rowCount === this.itemsPerPage) {
      this.rowCount = this.rowCount * 2;
    }
    this.searchModified = true;
    this.getInspectionData();
    this.inspectionService.setAllInspectionIds([]);
    this.hideFilter = false;
  }

  reset()
  {
    this.selectedCheckLists = [];
    this.inspectionCheckLists.forEach((element) => {
      this.selectedCheckLists.push(element.value);
    });
    this.inspectionFromDate = null;
    this.inspectionToDate = null;
    this.searchText = "";
    this.inspectionFilter.PageIndex = 0;
    this.selectedUnit = [];
    this.selectedStatusId = [];
    this.inspectionStatus.forEach((status) => {
      this.selectedStatusId.push(status.value);
    });
    this.searchModified = true;
    this.inspectionService.setAllInspectionIds([]);
    this.RedirectFromDashboard = 0;
  }

  resetFilter() {
    this.reset();
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    this.getInspectionData();
    this.onClickedOutside();
  }
  onYesClickedForConfirmation() { }
  onNoClickedForConfirmation() { }
  onOkClicked() { }
  selectInspection(inspection, event) {
    let inspections = this.inspectionService.getAllInspectionIds();
    if (event.target.checked) {
      let insElem: StoredInspection = new StoredInspection();
      insElem.InspectionId = inspection.InspectionRequestId;
      inspections.push(insElem);
    } else {
      this.isInspectionsChecked = false;
      this.inspectionFilter.SelectAll = this.isInspectionsChecked;
      for (let index = 0; index < inspections.length; index++) {
        const element = inspections[index];
        if (inspections.InspectionId === element.InspectionRequestId) {
          inspections.splice(index, 1);
          break;
        }
      }
    }
    this.inspectionService.setAllInspectionIds(inspections);
    this.baseService.setFilterData(
      "inspectionFilter",
      JSON.stringify(this.inspectionFilter)
    );
  }
  selectAllInspections(checked) {
    
    let selectedInspections: StoredInspection[] = [];
    this.inspectionData.forEach((element) => {
      if (checked) {
        element.Checked = true;
        let insElem: StoredInspection = new StoredInspection();
        insElem.InspectionId = element.InspectionRequestId;
        //selectedInspections = this.inspectionService.getAllInspectionIds();
        if (!selectedInspections) {
          selectedInspections = [];
        }
        selectedInspections.push(insElem);
        this.inspectionService.setAllInspectionIds(selectedInspections);
      } else {
        element.Checked = false;
        this.inspectionService.setAllInspectionIds([]);
      }
    });
    this.inspectionFilter.SelectAll = this.isInspectionsChecked;
    this.baseService.setFilterData(
      "inspectionFilter",
      JSON.stringify(this.inspectionFilter)
    );
  }
  goToInspection(inspectionId) {
    
    let inspections = this.inspectionService.getAllInspectionIds();
    if (
      !inspections.find((element) => {
        if (element.InspectionId === inspectionId) {
          return true;
        }
      })
    ) {
      let insElem: StoredInspection = new StoredInspection();
      insElem.InspectionId = inspectionId;
      inspections.push(insElem);
      
    }
    this.inspectionService.setAllInspectionIds(inspections);
    this.getCurrentDOMElementId(inspectionId);
    this.router.navigate(["inspection/add-inspection/" + inspectionId]);
  }
  getCurrentDOMElementId(id) {
    this.inspectionService.setcurrentInspectionRequestId(id);
  }
  ngAfterViewChecked() {
    let currentIncidentRequestId = this.inspectionService.getcurrentInspectionRequestId();
    if (currentIncidentRequestId !== 0) {
      this.highlightCurrentSelectedActionTracker(currentIncidentRequestId);
    }
  }
  highlightCurrentSelectedActionTracker(id) {
    var el = document.getElementById(id);
    while (!this.checked && el !== null) {
      this.checked = true;
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      let currentColor = document.getElementById(id).style.backgroundColor;
      if (currentColor !== null && currentColor !== "darkgray") {
        document.getElementById(id).style.backgroundColor = "darkgray";
      }
      el = null;
    }
  }
  downloadZIP() {
    this.disableExport = true;
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Downloading is in progress!"
    );
    this.inspectionSourceIdsDetails = [];
    this.inspectionService.getAllInspectionIds().forEach((element) => {
      this.inspectionSourceIdsDetails.push({
        ProcessName: "Inspection",
        SourceId: element.InspectionId,
        UserId: this.loggedInUserJSON.UserId,
      });
    });
    if (this.inspectionSourceIdsDetails.length > 0) {
      const apiRequest = {
        Model: {
          SourceIds: this.inspectionSourceIdsDetails,
        },
      };
      this.observationService.downloadZIP(
        apiRequest,
        this.callbackMethodForDownloadZIP.bind(this)
      );
    }
  }
  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_inspection.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  downloadPDF(inspectionId) {
    this.currentId = inspectionId;
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName:
          "Inspection",
        SourceId: inspectionId
      }
    };
    this.observationService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this)
    );
  }

  callbackMethodForDownloadPDF(response) {
    var data = response;

    //Here assign the Byte array  returned from API to data variable
    var fileDownLoadName = "pdf_inspection" + this.currentId + ".pdf"; //Here we can assign name of the document
    FileUtility.downloadPDF(response, fileDownLoadName);
  }

  getOutput(output) {
    if (output) {
      this.ngOnInit();
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Record is in use!');
    }
  }

}
export class StoredInspection {
  InspectionId: number;
}
